import queryString from 'query-string';
import {IBaseSearchParam} from '../Types/ISearchParam';

export const parseSearchParametersFromUrl = (search: string): IBaseSearchParam | null => {
    const parsedQuery: queryString.ParsedQuery = queryString.parse(search);
    const longitude: number | null = typeof parsedQuery.longitude === 'string' ? parseFloat(parsedQuery.longitude) : null;
    const latitude: number | null = typeof parsedQuery.latitude === 'string' ? parseFloat(parsedQuery.latitude) : null;
    const location: string | null = parsedQuery.location ? parsedQuery.location as string : null;
    const date: string | null = parsedQuery.date ? parsedQuery.date as string : null;
    const vehicleType: string | null = parsedQuery.vehicleType ? parsedQuery.vehicleType as string : null;
    let searchParam: IBaseSearchParam | null = null;

    if (
        longitude !== null &&
        latitude !== null &&
        location !== null &&
        date !== null
    ) {
       searchParam = {
           longitude,
           latitude,
           location,
           date
       }
    }

    if (vehicleType !== null && searchParam !== null) {
        searchParam.vehicleType = vehicleType;
    }

    return searchParam;
}
